import { render } from "./ProposalAwaitingActions.vue?vue&type=template&id=f06d8c1c&ts=true"
import script from "./ProposalAwaitingActions.vue?vue&type=script&lang=ts"
export * from "./ProposalAwaitingActions.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__